import styled from 'styled-components'

import { Accordion } from '@/components/elements/Accordion'
import { AHeading } from '@/components/enlayouts/Ir/Heading'
import { PDFList } from '@/components/enlayouts/Ir/PDFList'

import type { AccordionProps } from '@/pages/ir/financial/monthly-sales'

type MonthlySalesProps = {
  yearsPdf: Array<AccordionProps>
}

export const MonthlySalesPDF = ({ yearsPdf }: MonthlySalesProps) => {
  return (
    <>
      <AHeading>Back Number</AHeading>
      <Section>
        {yearsPdf.map((value, index) => (
          <div key={`${index}${value.accordionTitle}`}>
            <Accordion
              accordionTitle={value.accordionTitle}
              contentsLength={value.accordionItems.length}
              isDefaultOpen={value.isDefaultOpen}
            >
              <PDFList pdfList={value.accordionItems} />
            </Accordion>
          </div>
        ))}
      </Section>
    </>
  )
}

const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 50px;
`
